import { useEffect, useState } from 'react'

import AnimateShowIn from '@/gf/components/AnimateShowIn'
import VendorForm from './VendorForm'
import VendorView from './VendorView'
import { useContext } from '../Vendor'

const Sidebar = () => {
  const [editing, setEditing] = useState(false)
  const { refetchVendor, initialEditMode } = useContext()

  // Set editing mode based on URL query parameter
  useEffect(() => {
    if (initialEditMode) {
      setEditing(true)
    }
  }, [initialEditMode])

  const onAfterSave = () => {
    setEditing(false)
    refetchVendor()
  }

  return (
    <>
      <AnimateShowIn visible={editing}>
        <VendorForm onAfterSave={onAfterSave} onCancel={() => setEditing(false)} />
      </AnimateShowIn>

      <AnimateShowIn visible={!editing}>
        <VendorView onEditClick={() => setEditing(true)} />
      </AnimateShowIn>
    </>
  )
}

export default Sidebar
